<template>
  <footer>
    <div class="logo-wrap">
      <Logo class="logo"/>
      <Wordmark class="wordmark"/>
    </div>
  </footer>
</template>

<script>

import Wordmark from '@/assets/icon/wordmark.svg?inline'
import Logo from '@/assets/icon/logo.svg?inline'
export default {
  name: 'Footer',
  components: {
    Logo,
    Wordmark
  }
}
</script>

<style lang="scss">

footer{
  @extend %center-flex;
  width: 100%;
  height: 260px;
  @media #{$maxM}{
    height: 157px;
  }
    .logo-wrap{ 
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 66px;
      height: 66px;
      @media #{$maxM}{
        width: 42px;
        height: 42px;
      }
        svg{
          display: block;
          width: 100%;
          height: auto;
        }
        svg.logo{
              margin-bottom: 9px;
              @media #{$maxM}{
                margin-bottom: 6px;
              }
        }
    }
}
</style>
